<template>
  <div class="news-detail">
    <div class="page-header">
      <div class="container">
        <h1>{{ news.title }}</h1>
        <p class="meta">
          <span class="date">{{ news.date }}</span>
          <span class="category">{{ news.category }}</span>
        </p>
      </div>
    </div>

    <div class="container">
      <div class="content">
        <div class="cover-image">
          <img :src="news.image" :alt="news.title">
        </div>
        <div class="article" v-html="news.content"></div>
      </div>
    </div>
  </div>
</template>

<script setup >
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const news = ref({
  title: '',
  date: '',
  category: '',
  image: '',
  content: ''
})

onMounted(async () => {
  // 这里可以根据 route.params.id 获取新闻详情
  // 模拟数据
  news.value = {
    title: '美音科技荣获2023年度优秀服务商称号',
    date: '2023-12-20',
    category: '公司新闻',
    image: require('@/assets/images/15.png'),
    content: `
      <p>在2023年度评选中，湖南美音凭借优质的服务能力和创新的技术方案，荣获"2023年度优秀服务商"称号。</p>
      <p>这一荣誉的获得，是对公司多年来在IT服务领域深耕细作的肯定，也是对我们持续创新、追求卓越的鼓励。</p>
      <h3>创新服务模式</h3>
      <p>湖南美音始终坚持以客户需求为导向，不断创新服务模式，提升服务质量。通过建立完善的服务体系，引入先进的管理工具，为客户提供更加专业、高效的IT运维服务。</p>
      <h3>技术实力展现</h3>
      <p>公司在IT运维、系统集成、数据治理等领域具备深厚的技术积累，拥有一支经验丰富的专业团队。通过持续的技术创新和服务优化，不断提升客户满意度。</p>
    `
  }
})
</script>

<style lang="scss" scoped>
.news-detail {
  .page-header {
    background: linear-gradient(135deg, #2b5dff 0%, #1a45e0 100%);
    color: #fff;
    padding: 60px 0;
    text-align: center;

    h1 {
      font-size: 32px;
      margin-bottom: 16px;
    }

    .meta {
      font-size: 14px;
      opacity: 0.8;

      span {
        margin: 0 10px;
      }
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .content {
    padding: 60px 0;
    max-width: 800px;
    margin: 0 auto;

    .cover-image {
      margin-bottom: 40px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

      img {
        width: 100%;
        height: auto;
      }
    }

    .article {
      color: #333;
      line-height: 1.8;

      h3 {
        font-size: 24px;
        margin: 30px 0 20px;
        color: #1a1a1a;
      }

      p {
        margin-bottom: 20px;
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 768px) {
  .news-detail {
    .page-header {
      padding: 40px 0;

      h1 {
        font-size: 24px;
      }
    }

    .content {
      padding: 40px 0;
    }
  }
}
</style> 